import instance from "./request";
 
interface ReqLogin {
    mobile: string
    verificationCode: string
    code:string
    scene:string
}
 
 
// Res是返回的参数，T是泛型，需要自己定义，返回对数统一管理***
type Res<T> = Promise<ItypeAPI<T>>;
interface ItypeAPI<T> {
[x: string]: any;
    result: any,//请求的数据，用泛型
    msg: string | null // 返回状态码的信息，如请求成功等
    code: number //返回后端自定义的200，404，500这种状态码
    success:boolean
    timestamp:string
}
 
 
// 获取短信验证码
export const sendSms = (data:any): Res<string> => 
    instance.post("/api/account/sendSms",data);
 
// 短信验证登录
export const signInByMobile = (data: ReqLogin): Res<string> =>
    instance.post("/api/account/signInByMobile", data);
 
// 微信授权后获取身份信息
export const signInByWechat	 = (params:any): any => 
    instance.get("/api/account/signInByWechat", { params });

// 获取用户视频状态
export const getVideoStatus = (params:any): any => 
    instance.get("/api/subo/videoSetting", { params });
// 设置用户已读视频
export const setVideo = (data:any): Res<String> => 
    instance.post("/api/subo/setVideo", data);
 